export enum ManagementTabsKeys {
  USERS = "USERS",
  CMS_SETTINGS = "CMS_SETTINGS",
}

export const DEFAULT_MANAGEMENT_TAB_KEY = ManagementTabsKeys.USERS;